<!-- eslint-disable vue/no-v-html -->
<template>
  <li class="sc__iconNavBar__item">
    <a
      :href="ctaUrl"
      @click="onLinkClick()"
    >
      <span
        class="sc__iconNavBar__item__icon"
        v-html="getIcon"
      />
      {{ ctaText }}
    </a>
  </li>
</template>

<script lang="js">
import { fireUtagEvent } from '@garmin/support-analytics';
import Icons from './icons';

export default {
  name: 'ScIconNavBarItem',
  props: {
    ctaText: {
      type: String,
      required: true,
    },
    ctaUrl: {
      type: String,
      required: true,
    },
    gaEventString: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      required: true,
      validator(value) {
        return Object.keys(Icons).indexOf(value) !== -1;
      },
    },
  },
  computed: {
    getIcon() {
      return Icons[this.icon];
    },
  },
  methods: {
    onLinkClick() {
      if (this.gaEventString) fireUtagEvent(this.gaEventString);
    },
  },
};
</script>

<style scoped lang="scss">
.sc__iconNavBar__item {

  a {
    text-transform: uppercase;
    text-decoration: none;
    @include font-accent();
    display: inline-block;
    vertical-align: middle;
  }

  &__icon {
    display: block;
    width: 7em;
    margin: 0 auto;
  }
}
</style>
